import React from "react";
import { Link, LinkProps } from "@chakra-ui/react";

export function CCV(props: LinkProps) {
  return (
    <Link {...props} href="https://ccv.brown.edu/">
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 810 306"
        xmlSpace="preserve"
      >
        <g>
          <path
            fill="#FFC72C"
            d="M117,98c-4.4,0-8-3.6-8-8V18c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H117z"
          />
        </g>
        <g>
          <path
            fill="#FFC72C"
            d="M216,98c-4.4,0-8-3.6-8-8V18c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H216z"
          />
        </g>
        <g>
          <path
            fill="#FFC72C"
            d="M18,197c-4.4,0-8-3.6-8-8v-72c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H18z"
          />
        </g>
        <g>
          <path
            fill="#FFC72C"
            d="M117,296c-4.4,0-8-3.6-8-8v-72c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H117z"
          />
        </g>
        <g>
          <path
            fill="#FFC72C"
            d="M216,296c-4.4,0-8-3.6-8-8v-72c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H216z"
          />
        </g>
        <g>
          <path
            fill="#00B398"
            d="M316,97c-4.4,0-8-3.6-8-8V17c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H316z"
          />
        </g>
        <g>
          <path
            fill="#00B398"
            d="M415,97c-4.4,0-8-3.6-8-8V17c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H415z"
          />
        </g>
        <g>
          <path
            fill="#00B398"
            d="M217,196c-4.4,0-8-3.6-8-8v-72c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H217z"
          />
        </g>
        <g>
          <path
            fill="#00B398"
            d="M316,295c-4.4,0-8-3.6-8-8v-72c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H316z"
          />
        </g>
        <g>
          <path
            fill="#00B398"
            d="M415,295c-4.4,0-8-3.6-8-8v-72c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v72c0,4.4-3.6,8-8,8H415z"
          />
        </g>
        <g>
          <path
            fill="#FFC72C"
            d="M594,190c0,4.4-3.6,8-8,8h-72c-4.4,0-8-3.6-8-8v-72c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8V190z"
          />
        </g>
        <g>
          <path
            fill="#FFC72C"
            d="M594,91c0,4.4-3.6,8-8,8h-72c-4.4,0-8-3.6-8-8V19c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8V91z"
          />
        </g>
        <g>
          <path
            fill="#FFC72C"
            d="M693,289c0,4.4-3.6,8-8,8h-72c-4.4,0-8-3.6-8-8v-72c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8V289z"
          />
        </g>
        <g>
          <path
            fill="#FFC72C"
            d="M792,190c0,4.4-3.6,8-8,8h-72c-4.4,0-8-3.6-8-8v-72c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8V190z"
          />
        </g>
        <g>
          <path
            fill="#FFC72C"
            d="M792,91c0,4.4-3.6,8-8,8h-72c-4.4,0-8-3.6-8-8V19c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8V91z"
          />
        </g>
      </svg>
    </Link>
  );
}
